// Generated by scripts/mdi/import-questionnaires.mjs from MDI "Finasteride & Dutasteride (WOMEN'S & MEN) 3.31.26 09.17.26" (6fb13b51-981f-4fe0-99b6-fa926b298be9). Re-run instead of editing.
import { FormType } from '../../../form-types';
import { mdiFinasterideDutasterideWomensMENAnswerField } from './questions';

export const mdiFinasterideDutasterideWomensMEN: FormType<mdiFinasterideDutasterideWomensMENAnswerField> =
  {
    name: "Finasteride & Dutasteride (WOMEN'S & MEN)",
    validityLength: 25,
    questions: [
      {
        key: 'mdiFinasterideDutasterideWomensMEN_sex',
        next: {
          switch: [
            {
              condition: {
                'mdiFinasterideDutasterideWomensMEN_sex.female': true
              },
              key: 'mdiFinasterideDutasterideWomensMEN_pregnancy'
            },
            {
              condition: {
                'mdiFinasterideDutasterideWomensMEN_sex.male': true
              },
              key: 'mdiFinasterideDutasterideWomensMEN_tryingConceivePlanConceivingNear'
            },
            {
              condition: {
                'mdiFinasterideDutasterideWomensMEN_pregnancy.yes': true
              },
              key: 'mdiFinasterideDutasterideWomensMEN_wereSorryButBasedPrevious'
            },
            {
              condition: {
                'mdiFinasterideDutasterideWomensMEN_tryingConceivePlanConceivingNear.yes':
                  true
              },
              key: 'mdiFinasterideDutasterideWomensMEN_wereSorryButBasedPrevious'
            }
          ],
          els: 'mdiFinasterideDutasterideWomensMEN_experiencingDiffuseThinning'
        }
      },
      {
        key: 'mdiFinasterideDutasterideWomensMEN_pregnancy',
        next: {
          switch: [
            {
              condition: {
                'mdiFinasterideDutasterideWomensMEN_sex.male': true
              },
              key: 'mdiFinasterideDutasterideWomensMEN_tryingConceivePlanConceivingNear'
            },
            {
              condition: {
                'mdiFinasterideDutasterideWomensMEN_pregnancy.yes': true
              },
              key: 'mdiFinasterideDutasterideWomensMEN_wereSorryButBasedPrevious'
            },
            {
              condition: {
                'mdiFinasterideDutasterideWomensMEN_tryingConceivePlanConceivingNear.yes':
                  true
              },
              key: 'mdiFinasterideDutasterideWomensMEN_wereSorryButBasedPrevious'
            }
          ],
          els: 'mdiFinasterideDutasterideWomensMEN_experiencingDiffuseThinning'
        }
      },
      {
        key: 'mdiFinasterideDutasterideWomensMEN_tryingConceivePlanConceivingNear',
        next: {
          switch: [
            {
              condition: {
                'mdiFinasterideDutasterideWomensMEN_pregnancy.yes': true
              },
              key: 'mdiFinasterideDutasterideWomensMEN_wereSorryButBasedPrevious'
            },
            {
              condition: {
                'mdiFinasterideDutasterideWomensMEN_tryingConceivePlanConceivingNear.yes':
                  true
              },
              key: 'mdiFinasterideDutasterideWomensMEN_wereSorryButBasedPrevious'
            }
          ],
          els: 'mdiFinasterideDutasterideWomensMEN_experiencingDiffuseThinning'
        }
      },
      'mdiFinasterideDutasterideWomensMEN_wereSorryButBasedPrevious',
      'mdiFinasterideDutasterideWomensMEN_experiencingDiffuseThinning',
      'mdiFinasterideDutasterideWomensMEN_primaryConcern',
      'mdiFinasterideDutasterideWomensMEN_didFirstNoticeHairLoss',
      'mdiFinasterideDutasterideWomensMEN_whereHairLossOccurring',
      'mdiFinasterideDutasterideWomensMEN_hairLoss',
      'mdiFinasterideDutasterideWomensMEN_familyHistoryHairloss',
      {
        key: 'mdiFinasterideDutasterideWomensMEN_previouslyUsedTreatments',
        next: {
          switch: [
            {
              condition: {
                'mdiFinasterideDutasterideWomensMEN_previouslyUsedTreatments.minoxidil':
                  true
              },
              key: 'mdiFinasterideDutasterideWomensMEN_describePreviousExperiencePriorTreatments'
            },
            {
              condition: {
                'mdiFinasterideDutasterideWomensMEN_previouslyUsedTreatments.finasteride':
                  true
              },
              key: 'mdiFinasterideDutasterideWomensMEN_describePreviousExperiencePriorTreatments'
            },
            {
              condition: {
                'mdiFinasterideDutasterideWomensMEN_previouslyUsedTreatments.dutasteride':
                  true
              },
              key: 'mdiFinasterideDutasterideWomensMEN_describePreviousExperiencePriorTreatments'
            },
            {
              condition: {
                'mdiFinasterideDutasterideWomensMEN_previouslyUsedTreatments.supplements':
                  true
              },
              key: 'mdiFinasterideDutasterideWomensMEN_describePreviousExperiencePriorTreatments'
            },
            {
              condition: {
                'mdiFinasterideDutasterideWomensMEN_previouslyUsedTreatments.prp_procedures':
                  true
              },
              key: 'mdiFinasterideDutasterideWomensMEN_describePreviousExperiencePriorTreatments'
            },
            {
              condition: {
                'mdiFinasterideDutasterideWomensMEN_previouslyUsedTreatments.other_please_specify':
                  true
              },
              key: 'mdiFinasterideDutasterideWomensMEN_describePreviousExperiencePriorTreatments'
            },
            {
              condition: {
                'mdiFinasterideDutasterideWomensMEN_sex.male': true
              },
              key: 'mdiFinasterideDutasterideWomensMEN_conditions'
            },
            {
              condition: {
                'mdiFinasterideDutasterideWomensMEN_sex.female': true
              },
              key: 'mdiFinasterideDutasterideWomensMEN_conditions2'
            }
          ],
          els: 'mdiFinasterideDutasterideWomensMEN_underCareChronicIllness'
        }
      },
      {
        key: 'mdiFinasterideDutasterideWomensMEN_describePreviousExperiencePriorTreatments',
        next: {
          switch: [
            {
              condition: {
                'mdiFinasterideDutasterideWomensMEN_sex.male': true
              },
              key: 'mdiFinasterideDutasterideWomensMEN_conditions'
            },
            {
              condition: {
                'mdiFinasterideDutasterideWomensMEN_sex.female': true
              },
              key: 'mdiFinasterideDutasterideWomensMEN_conditions2'
            }
          ],
          els: 'mdiFinasterideDutasterideWomensMEN_underCareChronicIllness'
        }
      },
      {
        key: 'mdiFinasterideDutasterideWomensMEN_conditions',
        next: {
          condition: { 'mdiFinasterideDutasterideWomensMEN_sex.female': true },
          key: 'mdiFinasterideDutasterideWomensMEN_conditions2',
          els: 'mdiFinasterideDutasterideWomensMEN_underCareChronicIllness'
        }
      },
      'mdiFinasterideDutasterideWomensMEN_conditions2',
      {
        key: 'mdiFinasterideDutasterideWomensMEN_underCareChronicIllness',
        next: {
          condition: {
            'mdiFinasterideDutasterideWomensMEN_underCareChronicIllness.yes':
              true
          },
          key: 'mdiFinasterideDutasterideWomensMEN_provideDoctorFurtherInsightRegarding',
          els: 'mdiFinasterideDutasterideWomensMEN_historyAllergicReactionFinasterideDutasteride'
        }
      },
      'mdiFinasterideDutasterideWomensMEN_provideDoctorFurtherInsightRegarding',
      {
        key: 'mdiFinasterideDutasterideWomensMEN_historyAllergicReactionFinasterideDutasteride',
        next: {
          switch: [
            {
              condition: {
                'mdiFinasterideDutasterideWomensMEN_historyAllergicReactionFinasterideDutasteride.yes':
                  true
              },
              key: 'mdiFinasterideDutasterideWomensMEN_explainOccurredDuringReactionMedication'
            },
            {
              condition: {
                'mdiFinasterideDutasterideWomensMEN_sex.male': true
              },
              key: 'mdiFinasterideDutasterideWomensMEN_everToldNotTake5'
            }
          ],
          els: 'mdiFinasterideDutasterideWomensMEN_provideDoctorFurtherInsightWhy'
        }
      },
      {
        key: 'mdiFinasterideDutasterideWomensMEN_explainOccurredDuringReactionMedication',
        next: {
          condition: { 'mdiFinasterideDutasterideWomensMEN_sex.male': true },
          key: 'mdiFinasterideDutasterideWomensMEN_everToldNotTake5',
          els: 'mdiFinasterideDutasterideWomensMEN_provideDoctorFurtherInsightWhy'
        }
      },
      'mdiFinasterideDutasterideWomensMEN_everToldNotTake5',
      'mdiFinasterideDutasterideWomensMEN_provideDoctorFurtherInsightWhy',
      'mdiFinasterideDutasterideWomensMEN_importantClickAttachedLinkReview',
      'mdiFinasterideDutasterideWomensMEN_firstMessageDoctor',
      'mdiFinasterideDutasterideWomensMEN_complete'
    ]
  };
